import PropTypes from 'prop-types';

import { setActiveLayout } from '../../helpers/product';
import { useTranslation } from 'react-i18next';

const ShopTopAction = ({
  getLayout,
  getFilterSortParams,
  productCount,
  sortedProductCount,
  currentPage,
  pageLimit,
  onPageLimitChange,
  sortOrder,
  onSortChange,
}) => {
  const { t } = useTranslation();
  const startItem =
    productCount > 0 ? (currentPage - 1) * pageLimit + 1 : 0;
  const endItem =
    productCount > 0
      ? Math.min(startItem + sortedProductCount - 1, productCount)
      : 0;

  return (
    <div className="shop-top-bar mb-35">
      <div className="select-shoing-wrap">

        <div className="shop-select page-size-select">
          <select
            value={pageLimit}
            onChange={(e) => onPageLimitChange(Number(e.target.value))}
          >
            <option value={9}>9</option>
            <option value={18}>18</option>
            <option value={36}>36</option>
          </select>
        </div>
        <p>
          {startItem}-{endItem} {t("of")} {productCount}
        </p>


      </div>

      <div className="shop-tab">

        <button
          onClick={(e) => {
            getLayout('grid two-column');
            setActiveLayout(e);
          }}
        >
          <i className="fa fa-th-large" />
        </button>
        <button
          onClick={(e) => {
            getLayout('grid three-column');
            setActiveLayout(e);
          }}
        >
          <i className="fa fa-th" />
        </button>
        <button
          onClick={(e) => {
            getLayout('list');
            setActiveLayout(e);
          }}
        >
          <i className="fa fa-list-ul" />
        </button>

        <div className="shop-select" style={{ marginTop: '8px' }}>
          <select
            value={sortOrder}
            onChange={(e) => onSortChange(e.target.value)}
          >
            <option value="">{t('Sort by')}</option>
            <option value="name_asc">{t('Name')}</option>
            <option value="price_asc">{t('Price low to high')}</option>
            <option value="price_desc">{t('Price high to low')}</option>
            <option value="fabric_asc">{t('Fabric')}</option>
          </select>
        </div>
      </div>
    </div>
  );
};

ShopTopAction.propTypes = {
  getFilterSortParams: PropTypes.func,
  getLayout: PropTypes.func,
  currentPage: PropTypes.number,
  onPageLimitChange: PropTypes.func,
  onSortChange: PropTypes.func,
  pageLimit: PropTypes.number,
  productCount: PropTypes.number,
  sortedProductCount: PropTypes.number,
  sortOrder: PropTypes.string,
};

export default ShopTopAction;
